module.exports = __webpack_public_path__ + "static/media/yelp-logo.36020a8d.png";